/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Filter properties specific to carrier delivery note bundles (includes carrierNameOutgoing)
 */
export enum CarrierDeliveryNoteBundlesFilterProperties {
  Name = 'name',
  BundleNumber = 'bundleNumber',
  Status = 'status',
  ConsignorName = 'consignorName',
  CarrierName = 'carrierName',
  CarrierNameOutgoing = 'carrierNameOutgoing',
  ConsigneeName = 'consigneeName',
  Discrepancies = 'discrepancies',
  PalletTickets = 'palletTickets',
  DateClosed = 'dateClosed',
  DateCreated = 'dateCreated',
  CheckoutDate = 'checkoutDate'
}
